<template>
  <mdc-dialog v-model="isOpen"
              class="mdc_dialog_wider"
              :title="title"
              :accept="'user.close' | trans"
              @cancel="close"
              @accept="close">

    <loader class="table-loader" v-if="!dataSet"></loader>


    <bar-chart :bardatasets="fetchBarDatasetForChart()" :withLabels="true" v-if="dataSet"
               :scaleLabelY="scaleY"
               :scaleLabelX="'report.blocks' | trans"
               :aspectRatio="false"
               :valueMax="valueMax"
               :vertical-line-point="verticalLinePoint"
               v-bind:show-legend="!(isChain || isPecs|| isPecsWithoutDiscrimination|| isPecsWithDiscrimination || isPecsWithItems) || isStageChain ? !!dataSet.data.length : false" :height="360"/>

    <h4 class="chart__title mb-3" v-if="!isChain && !isPecs && !isPecsWithoutDiscrimination && !isPecsWithDiscrimination && !isPecsWithItems">
      {{graphTitle}} {{stimulName}} ({{toLocaleDate(dataPoint)}}).
    </h4>
    <h4 class="chart__title mb-3" v-if="(isChain || isPecs || isPecsWithoutDiscrimination) && chartType === 1">
      {{isChain ? 'report.chart_for_step_daily' : isStageChain ? 'report.chart_for_steps_daily_pecs' : 'report.chart_for_step_daily_pecs' | trans}}: {{toLocaleDate(dataPoint)}}.
    </h4>
    <h4 class="chart__title mb-3" v-if="(isChain || isPecs || isPecsWithoutDiscrimination) && chartType !== 1">
      {{isChain ? 'report.chart_for_percent_daily' : isStageChain ? 'report.chart_for_steps_daily_pecs' : 'report.chart_for_percent_daily_pecs' | trans}}: {{toLocaleDate(dataPoint)}}.
    </h4>

    <h4 class="chart__title mb-3" v-if="(isPecsWithDiscrimination || isPecsWithItems) && !!this.isStageChain">
      {{graphTitle}} {{'protocol.category' | trans}} {{categoryInfo.title}} ({{toLocaleDate(dataPoint)}}).
    </h4>

    <h4 class="chart__title mb-3" v-if="(isPecsWithDiscrimination || isPecsWithItems) && !this.isStageChain">
      {{chartType === 1 ? 'protocol.chart_properties_per_day' : 'protocol.chart_properties_percent_per_day' | trans}}. {{'protocol.categoryTitle' | trans}} {{categoryInfo.title}} ({{toLocaleDate(dataPoint)}}).
    </h4>

  </mdc-dialog>
</template>

<script>

  import Loader from '../../loader/components/Loader';
  import lang from '../../../lang/translator';
  import axios from 'axios';
  import forEach from 'lodash/forEach';
  import maxBy from 'lodash/maxBy';
  import max from 'lodash/max';
  import moment from 'moment';

  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';

  export default {
    props: {
      'isVCD': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isChain': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isSimple': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isDtt': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecs': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithoutDiscrimination': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithDiscrimination': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isPecsWithItems': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'isStageChain': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'version': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'stimulName': {
        type: String,
        default() {
          return '';
        },
      },
      'chartType': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'dataPoint': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stimulId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'graphTitle': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'stageId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'categoryInfo': {
        type: [Array, Object],
        default() {
          return null;
        },
      }
    },
    data() {
      return {
        verticalLinePoint: [],
        apiUrl: '/protocols/assigned/',
        dataSet: null,
        valueMax: null,
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },

      title: function () {

        let title = lang.get('report.chart_for_stimul_daily');

        if(this.isChain){
          title = !!this.isStageChain ? lang.get('report.chart_for_steps_daily') : this.chartType === 1 ? lang.get('report.chart_for_step_daily') : lang.get('report.chart_for_percent_daily')
        }

        if(this.isPecs || this.isPecsWithoutDiscrimination){
          title = !!this.isStageChain ? lang.get('report.chart_for_steps_daily_pecs') : this.chartType === 1 ? lang.get('report.chart_for_daily_pecs') : lang.get('report.chart_for_perc_daily_pecs')
        }

        if(this.isPecsWithDiscrimination || this.isPecsWithItems){
          title = !!this.isStageChain ? lang.get('report.chart_for_category_daily_pecs') : this.chartType === 1 ? lang.get('protocol.chart_properties_per_day') : lang.get('protocol.chart_properties_percent_per_day');
        }


        return title;
      },

      scaleY: function () {

        let title = lang.get('report.reaction_count');

        if(this.isChain){
          title = !!this.isStageChain ? lang.get('report.reaction_count') : this.chartType === 1 ? lang.get('report.step_count') : lang.get('report.chart_percent_axes')
        }

        if(this.isPecs || this.isPecsWithoutDiscrimination){
          title = !!this.isStageChain ? lang.get('report.number_step_pecs_detail') : this.chartType === 1 ? lang.get('report.number_step_pecs') : lang.get('report.percent_step_pecs')
        }

        if(this.isPecsWithDiscrimination || this.isPecsWithItems){
          title = !!this.isStageChain ? lang.get('report.number_step_pecs_detail') : this.chartType === 1 ? lang.get('report.number_properties_pecs') : lang.get('report.percent_properties_pecs')
        }

        return title;
      }
    },
    components: {Loader, BarChart},
    mounted() {
      this.showChart();
    },
    methods: {
      close() {
        this.$emit('close');
      },

      toLocaleDate: function (date) {
        return moment(date*1000).format('DD.MM.YYYY')
      },

      async showChart() {
        let apiUrl = this.isVCD ? this.apiUrl + 'vcd/' : this.apiUrl;
        let url, params;
        
        if(this.isPecs){
          apiUrl = this.apiUrl + 'pecs-sentence-structure/';
        }

        if(this.isPecsWithoutDiscrimination){
          apiUrl = this.apiUrl + 'pecs-without-discrimination/';
        }

        if(this.isPecsWithDiscrimination){
          apiUrl = this.apiUrl + 'pecs-with-discrimination/';
        }

        if(this.isChain){
          apiUrl = this.apiUrl + 'chain/';
        }

        if(this.isSimple){
          apiUrl = this.apiUrl + 'simple/';
        }

        if(this.isDtt){
          apiUrl = this.apiUrl + 'dtt/';
        }

        if(this.isPecsWithItems){
          apiUrl = this.apiUrl + 'pecs-features-with-items/';
        }
        
        if((this.isPecs || this.isChain || this.isPecsWithoutDiscrimination) && !this.isStageChain && !this.isSimple && !this.isPecsWithItems){

          url = apiUrl + this.protocolId + '/detailed-mastered-cumulative-stat/'+ this.stageId;
          params = {
            date: this.dataPoint,
            type: this.chartType,
            version: this.version
          }

        } else if(this.isPecsWithItems) {

          url = apiUrl + this.protocolId + '/detailed-mastered-cumulative-stat/category/' + this.categoryInfo.id;
          params = {
            date: this.dataPoint,
            type: this.chartType,
            version: this.version
          }

        } else  if(this.isPecsWithDiscrimination) {

          if(this.isStageChain) {

            url = apiUrl + this.protocolId + '/detailed-session-mensuration/'+ this.stageId + '/task/' + this.stimulId;
            params = {
              date: this.dataPoint,
              type: this.chartType,
              version: this.version
            }

          } else{

            url = apiUrl + this.protocolId + '/detailed-mastered-cumulative-stat/'+ this.stageId + '/category/' + this.categoryInfo.id;
            params = {
              date: this.dataPoint,
              type: this.chartType,
              version: this.version
            }

          }

        }  else{

          url = apiUrl + this.protocolId + '/detailed-session-mensuration/'+ this.stimulId;
          params = {
            stageId: this.stageId,
            date: this.dataPoint,
            type: this.chartType
          }
        }
        
        
        let response = await axios.get(url, {
          params: params
        });
        this.dataSet = response.data.data;
      },

      getRandomColor(i) {

        let letter = i * 48 < 248 ? i * 40 : i * 24;
        let color = 'rgb('+letter+','+letter+','+letter+')' ;

        return color;
      },

      fetchBarDatasetForChart() {
        let data = [];
        let datasets = [];
        let i = 0;
        let label = '';
        let labels = [];
        let backgroundColor = null;
        
        
        if((!this.isChain && !this.isPecs && !this.isPecsWithoutDiscrimination && !this.isPecsWithDiscrimination && !this.isPecsWithItems) || this.isStageChain){

          if(this.dataSet.data.length){

            let arrayCount = [];

            forEach(this.dataSet.data, (item,index) => {

              data = item.answers;
              label = item.info.label;
              labels = this.dataSet.labels;
              backgroundColor = this.getRandomColor(index);
              datasets.push(new BarChartDataset({
                data, label, labels, backgroundColor
              }));

              let max = maxBy(data, 'y');
              arrayCount.push(max.y)

            });

            this.valueMax = max(arrayCount)*1.1;
            this.verticalLinePoint= this.dataSet.changes;

          } else{
            data = [];
            labels = [];
            backgroundColor = this.getRandomColor(1);
            datasets.push(new BarChartDataset({
              data, label, labels, backgroundColor
            }));

          }
        } else{

          if (this.chartType !== 1){
            this.valueMax = 110;
          }

          if(this.dataSet.length){
            forEach(this.dataSet, (item,index) => {
              data.push({
                x: item.index,
                y: item.count
              });

              labels.push(item.index);

            });

            label = '';
            backgroundColor = this.getRandomColor(1);
            datasets.push(new BarChartDataset({
              data, label, labels, backgroundColor
            }));

            if (this.chartType === 1){
              let max = maxBy(this.dataSet, 'maxCount');
              this.valueMax = max ? max.maxCount*1.1 : null;
            }

          } else{
            data = [];
            labels = [];
            backgroundColor = this.getRandomColor(1);
            datasets.push(new BarChartDataset({
              data, label, labels, backgroundColor
            }));

          }
        
        }

        return datasets;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ChartPopup.vue